/**
 * Gerencia a Web Push subscription: subscribe, unsubscribe, enviar ao backend.
 */
import api from "../config/axios";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) {
    output[i] = raw.charCodeAt(i);
  }
  return output;
}

let vapidKeyCache = null;

async function fetchVapidPublicKey() {
  if (vapidKeyCache) return vapidKeyCache;
  try {
    const { data } = await api.get("/api/push/vapid-key/");
    vapidKeyCache = data.public_key;
    return vapidKeyCache;
  } catch {
    return null;
  }
}

export async function subscribeToPush() {
  try {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      return { ok: false, reason: "unsupported" };
    }

    const permission = Notification.permission;
    if (permission !== "granted") {
      return { ok: false, reason: "permission-not-granted" };
    }

    const registration = await navigator.serviceWorker.ready;

    const existingSub = await registration.pushManager.getSubscription();
    if (existingSub) {
      await sendSubscriptionToBackend(existingSub);
      return { ok: true, existing: true };
    }

    const vapidKey = await fetchVapidPublicKey();
    if (!vapidKey) {
      return { ok: false, reason: "no-vapid-key" };
    }

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey),
    });

    await sendSubscriptionToBackend(subscription);
    return { ok: true, existing: false };
  } catch (err) {
    console.error("[Push] Erro ao fazer subscribe:", err);
    return { ok: false, reason: err?.message || "subscribe-failed" };
  }
}

async function sendSubscriptionToBackend(subscription) {
  const subJson = subscription.toJSON();
  await api.post("/api/push/subscribe/", {
    endpoint: subJson.endpoint,
    keys: {
      p256dh: subJson.keys.p256dh,
      auth: subJson.keys.auth,
    },
  });
}

export async function unsubscribeFromPush() {
  try {
    if (!("serviceWorker" in navigator)) return;
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (!subscription) return;

    const endpoint = subscription.endpoint;
    await subscription.unsubscribe();

    try {
      await api.post("/api/push/unsubscribe/", { endpoint });
    } catch {
      // best-effort
    }
  } catch (err) {
    console.error("[Push] Erro ao unsubscribe:", err);
  }
}
